import { Component, OnInit } from '@angular/core';
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {PedidosService} from "../../services/pedidos.service";
import {ModalKendo} from "../../lib/ModalKendo";

@Component({
  selector: 'app-modal-uberdirectdetalhes',
  templateUrl: './modal-uberdirectdetalhes.component.html',
  styleUrls: ['./modal-uberdirectdetalhes.component.scss']
})
export class ModalUberdirectdetalhesComponent extends ModalKendo implements OnInit {
  pedido: any = {};
  modoGrupoLojas = false;
  notificacoes = [];
  carregando = true;
  constructor( private  grupolojasService: GrupolojasService,
              private  pedidosService: PedidosService) {
    super()
  }


  ngOnInit(): void {
    const requisicao = this.modoGrupoLojas
      ? this.grupolojasService.listeNotificacaoesUberDoPedido(this.pedido)
      : this.pedidosService.listeNotificacaoesUberDoPedido(this.pedido.id);

    requisicao.then((notificacoes) => {
      this.carregando = false;
      this.notificacoes = notificacoes;
    }).catch((erro) => {
      this.carregando = false;
      alert(erro);
    })
  }



}
